import { cloneElement, type FunctionComponentElement, type HTMLAttributes, type JSX } from 'react';
import { cx } from '@linaria/core';
import { Provider, Tooltip as ReakitTooltip, TooltipArrow, TooltipReference, useTooltipState } from 'reakit';

import { defaulTooltipStyles } from './style';
import { type Placement } from './types';

export interface TooltipOptions {
  animated?: boolean | number;
  background?: string;
  id: string | number;
  placement?: Placement;
  tooltipClass?: string;
  withArrow?: boolean;
}

const defaultOptions: TooltipOptions = {
  animated: 250,
  background: 'var(--oc-primary-white, #fff)',
  id: 'default-id',
  placement: 'bottom',
  tooltipClass: '',
  withArrow: true,
};

export const Tooltip = ({
  children,
  disablePortal = false,
  options,
  title,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: FunctionComponentElement<any>;
  disablePortal?: boolean;
  options?: TooltipOptions;
  title: string | JSX.Element;
}): JSX.Element => {
  const { animated, background, id, placement, tooltipClass, withArrow }: TooltipOptions = {
    ...defaultOptions,
    ...(typeof options !== 'undefined' ? options : {}),
  };

  const tooltip = useTooltipState({
    animated,
    baseId: id.toString(),
    placement,
  });

  return (
    <Provider>
      <TooltipReference {...tooltip} ref={children.ref} {...children.props}>
        {(referenceProps: HTMLAttributes<HTMLElement>) => cloneElement(children, referenceProps)}
      </TooltipReference>
      <ReakitTooltip
        {...tooltip}
        // Takeover ads z-index: 101, so z-index this to 102 to sit above:
        style={{ background: 'none', padding: 0, zIndex: 102 }}
        unstable_portal={!disablePortal}
      >
        <div className={cx(defaulTooltipStyles, tooltipClass)} style={{ background }}>
          {withArrow && <TooltipArrow {...tooltip} style={{ fill: background }} />}
          {title}
        </div>
      </ReakitTooltip>
    </Provider>
  );
};
